export default __webpack_public_path__ + "static/Entenda0149-0cda40c304a686516d00990a798b757b.jpg";